<template>
  <div id="blank-layout">
    <!-- <router-view> </router-view> -->
    <slot />

    <blank-footer-menu />
  </div>
</template>

<script>
import BlankFooterMenu from "@/components/BlankFooterMenu.vue";

export default {
  components: {
    BlankFooterMenu,
  },
};
</script>